import { useMutation, useQueryClient } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

export function useResumeRegistrationCheckout() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (checkoutId: string) =>
      tournamentApi.resumeRegistrationCheckout(checkoutId),
    onSettled: () =>
      Promise.all([
        client.invalidateQueries({
          queryKey: queryKeys.tournaments.myRegistrationPayments(),
        }),
        client.invalidateQueries({
          queryKey: queryKeys.tournaments.myRegistrations(),
        }),
      ]),
  });
}
